import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://www.sistemasoh.cl/api';

// Crear instancia de axios con configuración por defecto
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor para agregar token y cache-busting a todas las solicitudes
api.interceptors.request.use(
  config => {
    // Obtener token fresco del localStorage para cada solicitud
    const token = localStorage.getItem('token');
    
    // Siempre reemplazar el header de Authorization con el token actual
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Agregar parámetro anti-caché en requests GET para forzar datos frescos
    if (config.method === 'get' || !config.method) {
      config.params = { ...config.params, _t: Date.now() };
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Para depurar, añadimos un interceptor de respuesta
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      console.error('Error de autenticación en solicitud:', error.config.url);
    }
    return Promise.reject(error);
  }
);

export default api;